import { render, staticRenderFns } from "./modalNewChatResidente.vue?vue&type=template&id=7204de1d&scoped=true"
import script from "./modalNewChatResidente.vue?vue&type=script&lang=js"
export * from "./modalNewChatResidente.vue?vue&type=script&lang=js"
import style0 from "./modalNewChatResidente.vue?vue&type=style&index=0&id=7204de1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204de1d",
  null
  
)

export default component.exports